__turbopack_context__.v({
  "body": "Terminal-module__XtFbiW__body",
  "error": "Terminal-module__XtFbiW__error",
  "header": "Terminal-module__XtFbiW__header",
  "headerBtn": "Terminal-module__XtFbiW__headerBtn",
  "headerLeft": "Terminal-module__XtFbiW__headerLeft",
  "headerRight": "Terminal-module__XtFbiW__headerRight",
  "input": "Terminal-module__XtFbiW__input",
  "inputLine": "Terminal-module__XtFbiW__inputLine",
  "line": "Terminal-module__XtFbiW__line",
  "prompt": "Terminal-module__XtFbiW__prompt",
  "terminal": "Terminal-module__XtFbiW__terminal",
  "terminalIcon": "Terminal-module__XtFbiW__terminalIcon",
});
